import 'whatwg-fetch';

export const WINDOW_RESIZED_EVENT = 'WINDOW_RESIZED_EVENT';
export const windowResizeAction = (location) => {
  return {
    type: WINDOW_RESIZED_EVENT
  }
}

export const ADJUST_UI_ON_PAGE_LOAD = 'ADJUST_UI_ON_PAGE_LOAD';
export const adjustUIOnPageLoadAction = () => {
  return {
    type: ADJUST_UI_ON_PAGE_LOAD
  }
}

export const COMPLETED_ADJUST_UI_ON_PAGE_LOAD = 'COMPLETED_ADJUST_UI_ON_PAGE_LOAD';
export const completedAdjustWindowOnPageLoadAction = () => {
  return {
    type: COMPLETED_ADJUST_UI_ON_PAGE_LOAD
  }
}

export const OPEN_MODAL = 'OPEN_MODAL';
export const openModalAction = (photoUrl, photoTitle, modalComponent) => {
  return {
    type: OPEN_MODAL,
    photoUrl: photoUrl,
    photoTitle: photoTitle,
    modalComponent: modalComponent
  }
}

export const CLOSE_MODAL = 'CLOSE_MODAL';
export const closeModalAction = () => {
  return {
    type: CLOSE_MODAL
  }
}

export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const setSearchQueryAction = (searchQuery) => {
  return {
    type: SET_SEARCH_QUERY,
    searchQuery: searchQuery
  }
}

export const TOGGLE_SEARCH_STARTED = 'SEARCH_STARTED';
export const toggleSearchStartedAction = () => {
  return {
    type: TOGGLE_SEARCH_STARTED
  }
}

export const TOGGLE_SEARCH_COMPLETED = 'SEARCH_COMPLETED';
export const toggleSearchCompletedAction = () => {
  return {
    type: TOGGLE_SEARCH_COMPLETED
  }
}

export const RECEIVE_PHOTOS = 'RECEIVE_PHOTOS';
export const receiveSearchedPhotosAction = (photosJson, isNewSearch, page, totalPages) => {
  return {
    type: RECEIVE_PHOTOS,
    photosJson: photosJson,
    isNewSearch: isNewSearch,
    page: page,
    totalPage: totalPages
  }
}

export const GET_FAVORITES = 'GET_FAVORITES';
export const getFavoritesAction = () => {
  return {
    type: GET_FAVORITES
  }
}

export const ADD_PHOTO_TO_FAVORITES = 'ADD_PHOTO_TO_FAVORITES';
export const addPhotoToFavoritesAction = (photo) => {
  return {
    type: ADD_PHOTO_TO_FAVORITES,
    url: photo.url,
    title: photo.title
  }
}

export let searchFlickrAction = (searchQuery, page) => {
	return (dispatch) => {

    let url = 'https://api.flickr.com/services/rest?';
    url += 'method=flickr.photos.search&';
    url += 'format=json&';
    url += 'api_key=80c0aff65590f93ed177cb65805fbec7&';
	  url += 'action=opensearch&';
    url += 'text='+searchQuery+'&';
    url += 'per_page=30&';
    url += 'media=photos&';
    url += 'content_type=1&';
    url += 'format=json&';
    url += 'page='+page+'&';
    url += 'nojsoncallback=1';

		return fetch(url, {
  			method: 'GET'
  	}).then(function(response) {
    	return response.json();
  	}).then(function(json) {
      if (json.photos.page === 1) {
        dispatch(receiveSearchedPhotosAction(json, true));
        dispatch(toggleSearchCompletedAction());
      } else {
        dispatch(receiveSearchedPhotosAction(json, false));
      }
  	}).catch(function(ex) {
    	console.log('parsing failed', ex);
  	});
	}
}



/** WEBPACK FOOTER **
 ** ./src/flickr-redux/actions.js
 **/